import * as React from 'react';
import {FunctionComponent} from 'react';
import {CalendarEvent} from '../../../../../Models/CalendarEvent';
import {addSeconds, format} from 'date-fns';
import {utcToZonedTime} from 'date-fns-tz';
import {classNames} from '../../../../Support/classNames';

interface OwnProps {
    number: number;
    isActive?: boolean;
    calendarEvents: CalendarEvent[];
    onCalendarEventClick: (calendarEvent: CalendarEvent) => void;
    onCreateClick: () => void;
}

export const Day: FunctionComponent<OwnProps> = ({
    isActive,
    number,
    calendarEvents,
    onCalendarEventClick,
    onCreateClick,
}) => {
    return (
        <div className={classNames('day', {'day--active': isActive})}>
            <div className="d-flex flex-row justify-content-between">
                <button className="day__btn btn btn-outline-secondary" onClick={() => onCreateClick()}>
                    Create
                </button>
                <span className="day__number">
                    <span>{number}</span>
                </span>
            </div>
            <div className="day__events">
                {calendarEvents.map((calendarEvent, index) => {
                    const startAt = utcToZonedTime(calendarEvent.startAt, calendarEvent.timezone);
                    return (
                        <button className="day__event" key={index} onClick={() => onCalendarEventClick(calendarEvent)}>
                            <p>{calendarEvent.title}</p>
                            <p>
                                {format(startAt, 'H:mm')} -{' '}
                                {format(addSeconds(startAt, calendarEvent.duration.seconds), 'H:mm')}
                            </p>
                            {calendarEvent.description !== '' && <p>{calendarEvent.description}</p>}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};
